import { Injectable } from '@angular/core';
import {SignalRHttpClient} from '../../core/services/signal-r-http-client';
import {EMPTY, Observable} from 'rxjs';
import {config} from '../config';
import {NotificationsWrapper} from '../models/notifications-wrapper';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {UpdateNotification} from '../models/update-notification';
import {Notification} from '../models/notification';
import {NotificationWrapper} from '../models/notification-wrapper';
import {NotificationStats} from '../models/notification-stats';
import {TranslateService} from '../../core/translate/translate.service';
import {HubService} from '../../core/services/hub.service';
import { AuthFacade } from '../../stores/auth/facades/auth.facade';
import { CoreFacade } from '../../stores/core/facades/core.facade';
import { ModalService } from '../../core/services/modal.service';
import { SocketsManagerService } from '../../sockets-manager/services';

@Injectable({
  providedIn: 'root'
})
export class NotificationService extends HubService {
  private page = 1;
  private pageSize = 10;
  private totalPages: number;

  constructor(
    protected signalRHttpClient: SignalRHttpClient,
    protected modalService: ModalService,
    protected translate: TranslateService,
    protected authFacade: AuthFacade,
    private http: HttpClient,
    private coreFacade: CoreFacade,
    protected socketsManagerService: SocketsManagerService,
    protected _coreFacade: CoreFacade
  ) {
    super('hubs/notification', modalService, translate, signalRHttpClient, authFacade, socketsManagerService, _coreFacade);
    const subscription = this.coreFacade.getNotificationStats$.subscribe(stats => {
      if (stats) {
        this.page = stats.currentPage;
        this.totalPages = stats.totalPages;
      }
    });
    this.subscriptions.add(subscription);
  }

  getNotifications(page): Observable<NotificationsWrapper> {
    const fields = ['*'];

    return this.http.get(config.generateApiUrl('notifications', fields, null, 2.2) + `&page=${page}&pageSize=${this.pageSize}`).pipe(
      map(request => {
        return request['data'] as NotificationsWrapper;
      })
    );
  }

  getNotificationByIds(ids: number[]): Observable<NotificationsWrapper> {
    if (!this.utils.hasValue(ids)) {
      return EMPTY;
    }
    const fields = ['*'];

    return this.http.get(config.generateApiUrl('notifications', fields, null, 2.2) + `&page=1&pageSize=${ids.length}&notificationIds=${ids.join(',')}`).pipe(
      map(request => {
        return request['data'] as NotificationsWrapper;
      })
    );
  }

  updateNotificationStatus(notificationToUpdate: UpdateNotification) {
    const fields = ['*'];
     return this.http.put(config.generateApiUrl('notifications', fields, null, 2.1), notificationToUpdate)
      .pipe(map(res => res['data']['item']));
  }

  update(notifications: Notification[]) {
    const list: Notification[] = Object.assign([], notifications);

    list.forEach(notification => {
      notification.date = this.utils.dateToLocal(notification.date).toString();
      notification.data = typeof notification.data === 'string' ? JSON.parse(notification.data) : notification.data;
    });


    return this.sortNotifications(list);
  }

  sortNotifications(notifications: Notification[]) {
    return notifications.sort(function(a, b) {
      const dateA: number = new Date(a.date).getTime();
      const dateB: number = new Date(b.date).getTime();
      return dateB - dateA;
    });
  }

  protected onConnection() {
    this.coreFacade.getNotifications(1);
  }

  protected onInit() {
    this.hubConnection.on('Notification', (data: NotificationWrapper) => {
      this.coreFacade.getNotificationByIds(data.notificationIds);
      this.coreFacade.setNotificationsStats(new NotificationStats(data.unreadNotificationsCount, this.page, this.totalPages));
    });
    this.hubConnection.on('UpdateNotification', (data: NotificationWrapper) => {
      this.coreFacade.getNotificationByIds(data.notificationIds);
      this.coreFacade.setNotificationsStats(new NotificationStats(data.unreadNotificationsCount, this.page, this.totalPages));
    });
  }

}
